import axios from 'axios'
import type {
  CreateHabitRequest,
  HabitCompletionDto,
  HabitDto,
  HabitWeekDto,
} from '../Models/Habit'

const apimSubscriptionKey = process.env.REACT_APP_APIM_SUBSCRIPTION_KEY

export const habitsAxios = axios.create({
  baseURL: process.env.REACT_APP_HABITS_API_BASE_URL ?? 'http://localhost:7072/api',
  headers: {
    'Content-Type': 'application/json',
    ...(apimSubscriptionKey ? { 'Ocp-Apim-Subscription-Key': apimSubscriptionKey } : {}),
  },
})

export const habitsApi = {
  getAll: () => habitsAxios.get<HabitDto[]>('/GetHabits').then((r) => r.data),
  getWeek: (weekStart: string) =>
    habitsAxios.get<HabitWeekDto>(`/GetHabitWeek/${weekStart}`).then((r) => r.data),
  create: (body: CreateHabitRequest) =>
    habitsAxios.post<HabitDto>('/CreateHabit', body).then((r) => r.data),
  update: (id: string, patch: Record<string, unknown>) =>
    habitsAxios.patch<HabitDto>(`/UpdateHabit/${id}`, patch).then((r) => r.data),
  delete: (id: string) => habitsAxios.delete(`/DeleteHabit/${id}`),
  setCompletion: async (habitId: string, date: string, completed: boolean) => {
    if (completed) {
      const { data } = await habitsAxios.put<HabitCompletionDto>(
        `/SetHabitCompletion/${habitId}/${date}`,
        { completed: true }
      )
      return data
    }
    await habitsAxios.put(`/SetHabitCompletion/${habitId}/${date}`, { completed: false })
    return null
  },
}
